'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import H5 from 'UIComponents/elements/headings/H5';
import KeyMirror from 'react-utils/keyMirror';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIToggleGroup from 'UIComponents/input/UIToggleGroup';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UIButton from 'UIComponents/button/UIButton';
import { usageTracker } from 'AdsUI/lib/usageTracker';
import UIForm from 'UIComponents/form/UIForm';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import StopPropagationWrapper from '../StopPropagationWrapper';
const TRACKING_STATUS_SURVEY_RESPONSES = KeyMirror({
  YES_: null,
  NO_: null,
  DONT_UNDERSTAND: null
});

class TrackingStatusSurvey extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isTrackingStatusHelpful: null,
      canContact: false
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  componentDidUpdate(lastProps) {
    if (this.props.open && !lastProps.open) {
      usageTracker.track('trackingStatusSurveyAction', {
        action: 'Clicked "was this helpful?"',
        status: this.props.status,
        isTrackingErrorsModal: false
      });
    }
  }

  onSubmit() {
    this.props.onClose();
  }

  onClose() {
    usageTracker.track('trackingStatusSurveyAction', {
      action: 'Closed survey without submitting',
      status: this.props.status,
      isTrackingErrorsModal: false
    });
    this.props.onClose();
  }

  renderSurvey() {
    const {
      isTrackingStatusHelpful,
      canContact
    } = this.state;
    return /*#__PURE__*/_jsxs("div", {
      className: "p-all-4",
      style: {
        minWidth: 200,
        maxWidth: 500
      },
      children: [/*#__PURE__*/_jsx(H5, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaigns.trackingStatus.survey.header"
        })
      }), /*#__PURE__*/_jsxs(UIForm, {
        children: [/*#__PURE__*/_jsx(UIToggleGroup, {
          name: "is-tracking-status-helpful",
          children: [TRACKING_STATUS_SURVEY_RESPONSES.YES_, TRACKING_STATUS_SURVEY_RESPONSES.NO_, TRACKING_STATUS_SURVEY_RESPONSES.DONT_UNDERSTAND].map(status => /*#__PURE__*/_jsx(UIRadioInput, {
            onChange: () => this.setState({
              isTrackingStatusHelpful: status
            }),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `campaigns.trackingStatus.survey.options.${status}`
            })
          }, status))
        }), /*#__PURE__*/_jsx(UICheckbox, {
          checked: canContact,
          onChange: e => this.setState({
            canContact: e.target.checked
          }),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "campaigns.trackingStatus.survey.canContact"
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "m-top-3",
          children: [/*#__PURE__*/_jsx(UIButton, {
            className: "p-x-8",
            use: "primary",
            onClick: this.onSubmit,
            disabled: !isTrackingStatusHelpful,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "submit"
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            className: "p-x-8",
            onClick: this.onClose,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "cancelButton"
            })
          })]
        })]
      })]
    });
  }

  render() {
    const {
      open,
      children
    } = this.props;
    return /*#__PURE__*/_jsx(UIPopover, {
      content: /*#__PURE__*/_jsx(StopPropagationWrapper, {
        children: this.renderSurvey()
      }),
      open: open,
      children: children
    });
  }

}

TrackingStatusSurvey.propTypes = {
  open: PropTypes.bool.isRequired,
  status: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};
export default TrackingStatusSurvey;